/** @format */

import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { Form, Col, Row, Layout, Typography } from 'antd'
import { MailOutlined } from '@ant-design/icons'

import InputField from '../../../components/Input'
import Button from '../../../components/Button'
import Images from '../../../components/Images'
import Spacer from '../../../components/Spacer'
import AuthSideBox from '../../../components/AuthSideBox'

import { serviceUserRecover } from './services'

import './style.css'

export default function Recover(props) {
	const [loading, setloading] = useState(false)

	const handleSubmitRecover = async (item) => {
		setloading(true)
		let response = await serviceUserRecover(item)
		setloading(false)
		if (response?.status) {
			props.history.push('/login')
		}
	}

	return (
		<Layout>
			<div className='ph-recover-responsive-logo-container'>
				<Images
					classContent={'ph-recover-responsive-logo'}
					webp={`${process.env.REACT_APP_STORAGE_IMAGES}/Logo-Pharol.webp`}
					jp2={`${process.env.REACT_APP_STORAGE_IMAGES}/Logo-Pharol.jp2`}
					jxr={`${process.env.REACT_APP_STORAGE_IMAGES}/Logo-Pharol.jxr`}
					default={`${process.env.REACT_APP_STORAGE_IMAGES}/Logo-Pharol.png`}
					title={'Logo'}
				/>
				<Typography.Text className='ph-recover-responsive-title'>Panel de Administración</Typography.Text>
			</div>
			<Layout.Content className='ph-recover-main-container'>
				<Row className='ph-recover-inner-container'>
					<Col span={24}>
						<Row>
							<Col xs={24} sm={10} md={9} lg={9} xl={8} className='ph-recover-authside-container'>
								<AuthSideBox />
							</Col>
							<Col xs={24} sm={14} md={15} lg={15} xl={16}>
								<div className='ph-recover-main-form-container'>
									<Row className='ph-recover-main-form-inner-container'>
										<Col span={24}>
											<h2 className='ph-recover-main-form-title'>Recuperar Contraseña</h2>
											<h3 className='ph-recover-main-form-description'>
												Ingresa tu correo para proceder...
											</h3>{' '}
											<Form
												className='ph-recover-form-content'
												name='normal_recover'
												initialValues={{ remember: true }}
												onFinish={handleSubmitRecover}>
												<InputField
													inputName={'email'}
													inputNameLabel={'Correo electrónico'}
													inputNameRule={true}
													inputNameMessage={'Ingresa tu correo!'}
													inputNameType={'email'}
													inputNameIcon={<MailOutlined />}
													inputNameRules={'rulesEmail'}
												/>
												<Form.Item>
													<div className='ph-recover-button-container'>
														<h3 className='ph-recover-button-register-description'>
															¿Ya tienes cuenta?
															<Link to='/login'>
																<span className='ph-recover-button-register-description-inner'>
																	Ingresa
																</span>
															</Link>
														</h3>
														<Spacer />
														<Button labelName={'Recuperar'} loadingSubmit={loading} />
													</div>
												</Form.Item>
											</Form>
										</Col>
									</Row>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
			</Layout.Content>
		</Layout>
	)
}
